import { lazy } from 'react';
import Loadable from '../layouts/loader/Loadable';
import { useSelector } from 'react-redux';
// import LoginView from '../views/auth/LoginFormik';
import { ProtectedRoute} from '../components/ProtectedRoute';
import { getSession } from '../libs/helper';
import { Navigate } from 'react-router-dom';


/****Layouts*****/
const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));
/***** Pages ****/
const Analytical = Loadable(lazy(() => import('../views_1/dashboards/Analytical')));


//const Demographical = Loadable(lazy(() => import('../views/dashboards/Demographical')));
//const Modern = Loadable(lazy(() => import('../views/dashboards/Modern')));
//const About = Loadable(lazy(() => import('../views/About')));

/***** Apps ****/
//const HelpCentre = Loadable(lazy(() => import('../views/apps/helpcentre/HelpCentre')));
//const ActivityLog = Loadable(lazy(() => import('../views/activitylog/ActivityLog')));

const TenantView = Loadable(lazy(() => import('../apps/tenants/views/TenantView')));
const EventView = Loadable(lazy(() => import('../apps/events/views/EventView')));
// const NotificationView = Loadable(lazy(() => import('../apps/emails/views/NotificationView')));

//const Email = Loadable(lazy(() => import('../views/email/Email')));
const Registration = Loadable(lazy(() => import('../apps/registrations/views/RegistrationView')));

const Error = Loadable(lazy(() => import('../views_1/auth/Error')));
const LoginView = Loadable(lazy(() => import('../apps/auth/views/LoginView')));

/*****Routes******/
const ThemeRoutes = [
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      { path: '/', name: 'Home', exact: true, element: <FullLayout><Analytical /></FullLayout>},
      { path: '/dashboards/analytical', name: 'Analytical', exact: true, element: <Analytical />},
      //{ path: '/activitylog', name: 'activitylog', exact: true, element: <FullLayout><ActivityLog /></FullLayout>},
      { path: '/tenants', name: 'tenant', exact: true, element: <FullLayout><TenantView /></FullLayout>},
      { path: '/registrations', name: 'registration', exact: true, element: <FullLayout><Registration /></FullLayout>},
      //{ path: '/notifications', name: 'email', exact: true, element: <FullLayout><NotificationView /></FullLayout>},
      { path: '/events', name: 'email', exact: true, element: <FullLayout><EventView  /></FullLayout>}
    ],
  },
  {

    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
      { path: 'login', element: <LoginView /> },
    ],
  },
];

export default ThemeRoutes;
